import { Component, OnInit, OnDestroy, ViewChild, ElementRef, HostListener } from "@angular/core";
import { ThemeService } from "../theme.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NewsAnimatorModel } from "../news-animator/news-animator.component";
import { AuthenticationService } from "src/app/services/authentication.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { HeaderService } from "./header.service";
import { ToastService } from "src/app/core/toast.service";
import { LanguageService } from "src/app/core/language.service";
import { SelectItem } from "primeng/api";
import {Subscription} from "rxjs";
import { fromEvent } from "rxjs";
import { debounceTime } from "rxjs/operators";

@Component({
    // tslint:disable-next-line: component-selector
    selector: "iti-header",
    styleUrls: ["./header.component.scss"],
    templateUrl: "./header.component.html"
})
export class HeaderComponent implements OnInit, OnDestroy {
    @ViewChild("headerNewsLabel", { static: false }) headerNewsLabel: ElementRef;
    pageTitle = "";
    isHeaderVisible = true;
    selectedLanguage = environment.defaultLang;
    newsMessages: Array<NewsAnimatorModel> = [];
    accountMenuItems: Array<any> = [];
    username = "";
    suggestedUsers: Array<any> = [];
    myProfile: any;
    isSettingsVisible = false;
    serverPath: string;
    selectedSearchUser: any;
    smallScreen: any;
    mobile: boolean = this.headerService.isMobile;
    mobileSubscription: Subscription | undefined;
    smallScreenSubscription: Subscription | undefined;
    languages: SelectItem[] = [
        { label: "English", value: "en" },
        { label: "Greek", value: "gr" },
        { label: "Albanian", value: "al" },
        { label: "Bulgarian", value: "bg" },
        { label: "Spanish", value: "es" },
    ];
    initialWidth: number = window.innerWidth;
    resizeSubscription: Subscription | undefined;

    constructor(private themeService: ThemeService,
        private router: Router,
        private authService: AuthenticationService,
        private httpClient: HttpClient,
        private headerService: HeaderService,
        private translateService: TranslateService,
        private toastService: ToastService,
        private languageService: LanguageService,
) {
    }

    get isOpen() {
        return this.themeService.animationState;
    }

    ngOnDestroy(): void {
        this.smallScreenSubscription.unsubscribe();
        this.mobileSubscription.unsubscribe();
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
    }

    ngOnInit(): void {
        this.smallScreenSubscription = this.headerService.subjectSmallScreen.subscribe((isSmallScreen: boolean) => {
            this.smallScreen = isSmallScreen;
        });
        this.mobileSubscription = this.headerService.subjectMobile.subscribe((isMobile: boolean) => {
            this.mobile = isMobile;
        });
        setTimeout(() => {
        this.headerService.setIsSmallScreen(window.innerWidth)
        this.headerService.setIsMobile(window.innerWidth);
    }, 10);

        this.selectedLanguage = this.languageService.getSelectedLanguage();
        this.serverPath = environment.serverPath;
        this.myProfile = this.authService.getLocalProfile();

        this.accountMenuItems = [
            { label: this.translateService.instant("general.logout"), routerLink: "/logout" }
        ];

        this.newsMessages = [];
        if (this.authService.getLocalProfile()) {
            this.username = this.authService.getLocalProfile().firstname;
        }

        // Subscribe to the resize event with debounceTime
        this.resizeSubscription = fromEvent(window, "resize")
        .pipe(debounceTime(300)) // Wait 300ms after the last event
        .subscribe(() => {
            if (this.initialWidth !== window.innerWidth) {
            this.initialWidth = window.innerWidth;
            this.headerService.setIsMobile(window.innerWidth);
            this.headerService.setIsSmallScreen(window.innerWidth);
            this.smallScreen = this.headerService.readIsSmallScreen();
            }
        });
    }
    selectedLanguageChanged(){
        this.languageService.changeLanguage(this.selectedLanguage);
    }

    pauseNewsAnimation() {
        this.headerNewsLabel.nativeElement.style["animation-play-state"] = "paused";
    }

    continueNewsAnimation() {
        this.headerNewsLabel.nativeElement.style["animation-play-state"] = "running";
    }

    logoutUser() {
        this.authService.logout();
        this.router.navigateByUrl("/login");
    }

    searchUsers(e) {
        const query = e.query;
        this.headerService.searchUser(query).subscribe(response => {
            // console.log(response);
            response.forEach(z => {
                z.name = z.firstname + " " + z.lastname;
            });
            this.suggestedUsers = response;
        });
    }

    userSelected(e) {
        this.router.navigateByUrl("/profile/" + e.id);
    }

    goToMyProfile() {
        this.router.navigateByUrl("/profile/" + this.myProfile.id + "/my-profile");
    }

    goToCommunities() {
        this.router.navigateByUrl("/communities");
    }

    goToEvents() {
        this.router.navigateByUrl("/events");
    }

    goToTimeline() {
        this.router.navigateByUrl("/");
    }

    showSettings() {
        this.isSettingsVisible = true;
    }

    settingsUpdated() {
        this.isSettingsVisible = false;
    }
}